export * from './story-cta-template.entity';